export default [
    {
        name: "The LoveLand Foundation",
        desc: "A foundation that provides therapy for Black women and girls",
        link: "https://thelovelandfoundation.org/",
        movements: ["blm"],
    },
    {
        name: "(F)EMPOWER Miami",
        desc:
            "These queer culture shifters are among the loudest voices advocating for community bailout funds among many other things",
        link: "https://linktr.ee/fempowermia",
        movements: ["lgbt"],
    },
    {
        name: "Dream Defenders Miami",
        desc:
            "Formed after the tragic murder of Trayvon Martin, this organization organizes peaceful protests, supports bail out funds, and has developed a trauma support center, among many, many other things",
        link: "https://dreamdefenders.org/",
        movements: ["blm"],
    },
    {
        name: "Campaign Zero",
        desc:
            "This organization seeks to end police violence by by pushing policy to limit police interventions, improve community interactions, and ensure accountability.",
        link: "https://www.joincampaignzero.org",
        movements: ["blm"],
    },

    {
        name: "Black Girls CODE",
        desc:
            "This organization aims to teach young black girls how to code to help them get future jobs in technology",
        link: "https://www.blackgirlscode.com/",
        movements: ["blm"],
    },
    {
        name: "Project No Labels",
        desc:
            "An organization based in Tampa that promotes volunteerism, activism and voice, and creative social gatherings, by creating a safe atmosphere for everyone regardless of orientation, gender, religion, color, beliefs (this is an LGBTQ+ organization)",
        link: "https://www.projectnolabels.org/",
        movements: ["lgbt"],
    },
    {
        name: "Come Out With Pride Orlando",
        desc:
            "An all-volunteer nonprofit organization inspired to make an impact in Orlando’s LGBTQ+ community",
        link: "https://comeoutwithpride.com/#home",
        movements: ["lgbt"],
    },
    {
        name: "National Bail Out",
        desc:
            "The National Bail Out collective is a Black-led and Black-centered collective of abolitionist organizers, lawyers and activists building a community-based movement to support black folks and end systems of pretrial detention and ultimately mass incarceration",
        link: "https://www.nationalbailout.org/",
        movements: ["blm"],
    },
    {
        name: "National Queer and Trans Therapists of Color Network",
        desc:
            "A healing justice organization committed to transforming mental health for queer and trans people of color (QTPoC)",
        link: "https://www.nqttcn.com/",
        movements: ["blm", "lgbt"],
    },
    {
        name: "Central Florida LGBTQ+ Relief Fund",
        desc:
            "This organization assists Orlando area LGBTQ+ community members who are most in need as a result of the COVID-19 crisis",
        link: "https://www.gofundme.com/f/central-florida-lgbtq-relief-fund",
        movements: ["lgbt"],
    },
    {
        name: "Victory Fund",
        desc:
            "The only national organization dedicated to electing openly LGBTQ people who can further equality at all levels of government",
        link: "https://victoryfund.org/",
        movements: ["lgbt"],
    },
    {
        name: "Black Trans Advocacy Coalition",
        desc:
            "This organization collectively addresses the inequities faced in the black transgender human experience",
        link: "https://blacktrans.org/about-us/",
        movements: ["blm", "lgbt"],
    },
    {
        name: "Transgender Awareness Alliance",
        desc:
            "Assist transgender persons in South Carolina with getting a legal name change, provide support for healthy living, and seek equality and equity through activism. They don't have a donation link, but check out their partnered charities",
        link: "https://www.taagg.org/",
        movements: ["lgbt"],
        noDonate: true, // means that they can't donate to them
    },
    {
        name: "LGBTQ Freedom Fund",
        desc:
            "Posts bail to secure the safety and liberty of LGBTQ individuals in U.S. jails and immigration facilities",
        link: "https://www.lgbtqfund.org/",
        movements: ["lgbt"],
    },
    {
        name:
            "The Griffin-Gracy Educational Retreat & Historical Center’s LGBTQ Freedom Fund",
        desc:
            "Creates programs, services, and resources that positively impact the lives, history, and visibility of Transgender, gender-questioning, and gender-nonconforming people",
        link: "https://houseofgg.org/",
        movements: ["lgbt"],
    },
    {
        name: "The Trevor Project",
        desc:
            "The leading national organization providing crisis intervention and suicide prevention services to lesbian, gay, bisexual, transgender, queer & questioning (LGBTQ) young people",
        link: "https://www.thetrevorproject.org/",
        movements: ["lgbt"],
    },
    {
        name: "The University Club Family Fund",
        desc:
            "University Club, a popular LGBTQ+ friendly nightclub, had to close recently due to COVID-19. They now find themselves with major financial responsibilities and no income, turning to the community for help. This fund helps alleviate their expenses",
        link:
            "https://www.gofundme.com/f/the-university-club-family-fund?utm_source=customer&utm_campaign=p_cp+share-sheet&utm_medium=copy_link-tip",
        movements: ["lgbt"],
    },
]
